import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";

class PageModalFooter extends Component {
  
  render() {
    return (
    <div>
        <Row>
        <Col className="col">
            <div className="form form-check form-switch form-switch-md mb-3"
                style={{ display: this.props.isEdit || this.props.hideAddAnother ?  "none" : "inline-block" }}
            >
            <input
                type="checkbox"
                className="form-check-input"
                id={this.props.id ?? "customSwitchsizelg"}
                onClick={this.props.onCheckboxClick}
                defaultChecked = {this.props.defaultChecked ?? false}
            />
            <label
                className="form-check-label"
                htmlFor={this.props.id ?? "customSwitchsizelg"}
            >
                {this.props.t("addAnother")}
            </label>
            </div>
        </Col>
        <Col className="col">
            <div
                style={{
                    textAlign: "right",
                    display: this.props.isDetail ? "none" : "block",
                }}
            >
            <button
                type="submit"
                className="btn btn-success save-event"
                style={{ marginRight: "3px" }}
            >
                {this.props.isEdit ? this.props.t("update") : this.props.t("save")}
            </button>
            <button
                type="button"
                className="btn btn-secondary save-customer"
                disabled={false}
                onClick={this.props.onCancelClick}
            >
                {this.props.t("cancel")}
            </button>
            </div>
        </Col>
        </Row>
        <Row>
            <Col sm={6} className="mb-6"></Col>
            <Col sm={6}>
            <div
                style={{
                    textAlign: "right",
                    display: !this.props.isDetail ? "none" : "block",
                }}
            >
                <button
                    type="button"
                    className="btn btn-secondary"
                    disabled={false}
                    onClick={this.props.onCancelClick}
                >
                {this.props.t("cancel")}
                </button>
            </div>
            </Col>
        </Row>
    </div>
    );
  }
}

PageModalFooter.propTypes = {
  hideAddAnother:PropTypes.bool,
  isEdit: PropTypes.bool.isRequired,
  isDetail: PropTypes.bool.isRequired,
  onCheckboxClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  id : PropTypes.func,
  defaultChecked : PropTypes.any,
  t: PropTypes.any,
};

export default (withTranslation()(PageModalFooter));
